import { useMemo } from 'react';
import { useEventType } from '@shared/utils/eventType';
import { CatalogStorefront, EventType } from '@graphql/generated';
import { useShopStorefrontContext } from '@apps/registry/common/components/Catalog/components/ShopStorefrontProvider';

export const useSameEventTypeStorefront = () => {
  const { eventType } = useEventType();
  const { currentStorefront } = useShopStorefrontContext();
  const hasSameEventTypeStorefront: boolean = useMemo(
    () =>
      (eventType === EventType.babyRegistry && currentStorefront === CatalogStorefront.baby) ||
      (eventType === EventType.wedding && currentStorefront === CatalogStorefront.wedding),
    [eventType, currentStorefront]
  );
  return { hasSameEventTypeStorefront };
};
